import { render } from "./AdminMenu.vue?vue&type=template&id=2fdd3c9f&scoped=true"
import script from "./AdminMenu.vue?vue&type=script&lang=js"
export * from "./AdminMenu.vue?vue&type=script&lang=js"

import "./AdminMenu.vue?vue&type=style&index=0&id=2fdd3c9f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdd3c9f"]])

export default __exports__